import { type SvgProps, SvgWrapper } from '../utils';

export function DownloadDoneIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M19.4697 3.46967C19.7626 3.17678 20.2374 3.17678 20.5303 3.46967C20.8232 3.76256 20.8232 4.23732 20.5303 4.53022L9.53027 15.5302C9.23738 15.8231 8.76262 15.8231 8.46973 15.5302C8.17683 15.2373 8.17683 14.7626 8.46973 14.4697L19.4697 3.46967Z" />
      <path d="M21 18.2499C21.4142 18.2499 21.75 18.5857 21.75 18.9999C21.75 19.4142 21.4142 19.7499 21 19.7499H3C2.58579 19.7499 2.25 19.4142 2.25 18.9999C2.25 18.5857 2.58579 18.2499 3 18.2499H21Z" />
      <path d="M3.46973 9.46967C3.76262 9.17678 4.23738 9.17678 4.53027 9.46967L9.53027 14.4697C9.82317 14.7626 9.82317 15.2373 9.53027 15.5302C9.23738 15.8231 8.76262 15.8231 8.46973 15.5302L3.46973 10.5302C3.17683 10.2373 3.17683 9.76256 3.46973 9.46967Z" />
    </SvgWrapper>
  );
}
